import EnumDataSource from "../../utils/enum-data-source.util";

export interface MigrationRecordsFilters {
  source?: string;
  target_model_name?: string;
  source_file_name?: string;
  status?: string;
  query?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
  search?: string;
}

export interface MigrationRecord {
  id: number;
  created_at: string;
  updated_at: string;
  source: number;
  source_id: string;
  source_file_name: string;
  target_model_name: string;
  target_model_id: string;
  error_message: string | null;
  status: number;
  data: Record<string, any>;
}

export interface MigrationRecordsResponse {
  count: number;
  results: MigrationRecord[];
}

export const MIGRATION_RECORDS_STATUS_ALL = "";
export const MIGRATION_RECORDS_STATUS_CREATED = 1;
export const MIGRATION_RECORDS_STATUS_SUCCESS = 2;
export const MIGRATION_RECORDS_STATUS_FAILED = 3;
export const MIGRATION_RECORDS_STATUS_SKIPPED = 4;

const MigrationQuickFiltersType = {
  [MIGRATION_RECORDS_STATUS_ALL]: "All",
  [MIGRATION_RECORDS_STATUS_CREATED]: "Created",
  [MIGRATION_RECORDS_STATUS_SUCCESS]: "Success",
  [MIGRATION_RECORDS_STATUS_FAILED]: "Failed",
  [MIGRATION_RECORDS_STATUS_SKIPPED]: "Skipped"
};

export const MIGRATION_RECORDS_QUICK_FILTER_TYPES = new EnumDataSource(
  MigrationQuickFiltersType
);

export const MIGRATION_RECORDS_SOURCE_SYCLE = 1;
export const MIGRATION_RECORDS_SOURCE_SYCLE_PRO = 2;
export const MIGRATION_RECORDS_SOURCE_HEARFORM = 3;
export const MIGRATION_RECORDS_SOURCE_CSV = 4;
export const MIGRATION_RECORDS_SOURCE_BLUEPRINT = 5;
export const MIGRATION_RECORDS_SOURCE_TIMS = 6;
export const MIGRATION_RECORDS_SOURCE_COUNSELEAR = 7;
export const MIGRATION_RECORDS_SOURCE_HEARINGFUSION = 8;
export const MIGRATION_RECORDS_SOURCE_TEBRA = 9;
export const MIGRATION_RECORDS_SOURCE_COMPULINK = 10;
export const MIGRATION_RECORDS_SOURCE_ADVANCEDMD = 11;
export const MIGRATION_RECORDS_SOURCE_AMPLIFY = 12;
export const MIGRATION_RECORDS_SOURCE_LESS_ANNOYING = 13;

const MigrationSources = {
  [MIGRATION_RECORDS_SOURCE_SYCLE]: "Sycle",
  [MIGRATION_RECORDS_SOURCE_SYCLE_PRO]: "Sycle Pro",
  [MIGRATION_RECORDS_SOURCE_HEARFORM]: "Hearform",
  [MIGRATION_RECORDS_SOURCE_CSV]: "CSV",
  [MIGRATION_RECORDS_SOURCE_BLUEPRINT]: "Blueprint",
  [MIGRATION_RECORDS_SOURCE_TIMS]: "Tims",
  [MIGRATION_RECORDS_SOURCE_COUNSELEAR]: "CounselEAR",
  [MIGRATION_RECORDS_SOURCE_HEARINGFUSION]: "HearingFUSION",
  [MIGRATION_RECORDS_SOURCE_TEBRA]: "Tebra",
  [MIGRATION_RECORDS_SOURCE_COMPULINK]: "Compulink",
  [MIGRATION_RECORDS_SOURCE_ADVANCEDMD]: "AdvancedMD",
  [MIGRATION_RECORDS_SOURCE_AMPLIFY]: "Amplify",
  [MIGRATION_RECORDS_SOURCE_LESS_ANNOYING]: "Less Annoying"
};

export const MIGRATION_RECORDS_SOURCES = new EnumDataSource(MigrationSources);
